import { render, staticRenderFns } from "./AccountsPayable.vue?vue&type=template&id=5720810b&scoped=true&"
import script from "./AccountsPayable.vue?vue&type=script&lang=js&"
export * from "./AccountsPayable.vue?vue&type=script&lang=js&"
import style0 from "./AccountsPayable.vue?vue&type=style&index=0&id=5720810b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5720810b",
  null
  
)

export default component.exports